import {alpha, type CSSObject, type Theme} from "@mui/material/styles";

/*
    Chip tints: range selection, and the `/` still being typed. Every selector names what this
    folder renders, so a host editor's other nodes and other suggestions keep their own styles.
 */
export const variableEditorSx = (theme: Theme): CSSObject => ({
    // Only in the focused editor, like the text selection it continues: a field left behind keeps its
    // selection in state, but the browser shows none there.
    "& .ProseMirror-focused .variable-in-selection [data-variable]": {
        backgroundColor: "Highlight",
        color: "HighlightText",
    },
    /*
        The chip shows its own selected state. tiptap puts the selected-node class on the node view's
        outer `span.node-variable`; `data-variable` sits on the chip inside it.
     */
    "& .node-variable.ProseMirror-selectednode": {outline: "none"},
    "& .variable-suggestion": {
        borderRadius: "4px",
        backgroundColor: alpha(theme.palette.text.primary, 0.08),
    },
    "& .variable-suggestion-empty::after": {
        content: "attr(data-decoration-content)",
        marginInlineStart: "2px",
        color: theme.palette.text.disabled,
        pointerEvents: "none",
    },
});

export default variableEditorSx;
